import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable import/no-internal-modules */
import { useTreeItemUtils } from '@mui/x-tree-view/hooks';
import { SimpleTreeView as MuiSimpleTreeViev } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem as MuiTreeItem } from '@mui/x-tree-view/TreeItem';
import React, { forwardRef } from 'react';
import { Skeleton } from '../skeleton';
import { TypographyWithTooltip } from '../typography';
export const SimpleTreeView = MuiSimpleTreeViev;
const TreeItem = forwardRef((props, ref) => {
    const { loading, ...treeItemProps } = props;
    const { selected } = useTreeItemUtils({ itemId: props.itemId }).status;
    const label = typeof treeItemProps.label === 'string' ? (_jsx(TypographyWithTooltip, { lineClamp: 2, color: selected ? 'primary.main' : undefined, fontWeight: selected ? 'bold' : 'normal', children: treeItemProps.label })) : (treeItemProps.label);
    return (_jsx(MuiTreeItem, { ref: ref, ...treeItemProps, label: loading ? _jsx(Skeleton, {}) : label, sx: {
            ...treeItemProps.sx,
            mb: 1,
            '&:last-child': { mb: 0 },
            '.MuiTreeItem-content': {
                py: 1
            }
        } }));
});
SimpleTreeView.TreeItem = TreeItem;
